import { page, services } from '@/utils'

export default {
  mixins: [ page(services['otp-settings/channels']) ]
}
